import React, { useLayoutEffect, useRef } from "react";

const HOURS = Array.from({ length: 24 }, (_, i) => String(i).padStart(2, "0"));
const MINUTES = Array.from({ length: 60 }, (_, i) => String(i).padStart(2, "0"));

function padTimePart(part) {
  return String(part ?? "0").padStart(2, "0");
}

function scrollActiveIntoView(container) {
  const active = container?.querySelector(".react-minimal-datetime-range__time-select-option.active");
  if (active) {
    active.scrollIntoView({ block: "center", behavior: "auto" });
  }
}

export default function LayerdTimeColumns({ dateLabel, hour, minute, onHour, onMinute }) {
  const hourScrollRef = useRef(null);
  const minuteScrollRef = useRef(null);
  const selectedHour = padTimePart(hour);
  const selectedMinute = padTimePart(minute);

  useLayoutEffect(() => {
    scrollActiveIntoView(hourScrollRef.current);
    scrollActiveIntoView(minuteScrollRef.current);
  }, [selectedHour, selectedMinute]);

  return (
    <div className="react-minimal-datetime-range__time-select-wrapper react-minimal-datetime-range__time-select-wrapper--single layerd-single-datetime-picker__time-columns">
      <div className="layerd-single-datetime-picker__time-date">
        <div className="react-minimal-datetime-range__date">{dateLabel}</div>
      </div>
      <div className="layerd-single-datetime-picker__time-scrolls">
        <div
          ref={hourScrollRef}
          className="react-minimal-datetime-range__time-select-options-wrapper"
        >
          {HOURS.map((h) => (
            <div
              key={h}
              className={`react-minimal-datetime-range__time-select-option${
                h === selectedHour ? " active" : ""
              }`}
              onClick={() => onHour(h)}
            >
              {h}
            </div>
          ))}
        </div>
        <div
          ref={minuteScrollRef}
          className="react-minimal-datetime-range__time-select-options-wrapper"
        >
          {MINUTES.map((m) => (
            <div
              key={m}
              className={`react-minimal-datetime-range__time-select-option${
                m === selectedMinute ? " active" : ""
              }`}
              onClick={() => onMinute(m)}
            >
              {m}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
